import { Link } from 'react-router-dom';

export default function AboutCTA() {
  return (
    <section className="py-16 sm:py-20 bg-[#5C4F8A]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
          Ready to Experience the KaliKare Difference?
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Let us show you how our personalized approach to homecare can make a meaningful 
          difference in your life or the life of someone you love.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/contact"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#5C4F8A] font-semibold rounded-full hover:bg-gray-100 transition-colors duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            Contact Us Today
          </Link>
          <Link 
            to="/services"
            className="inline-flex items-center justify-center px-8 py-4 bg-transparent text-white font-semibold rounded-full border-2 border-white hover:bg-white hover:text-[#5C4F8A] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-service-line mr-2 text-xl"></i>
            Explore Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}
